<template>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.rebotconfig_delete"
                   @click="handleDelete">删 除
        </el-button>
        <el-popover placement="right-start" width="480" trigger="hover" style="margin-left: 20px;">
          <div><el-tag>自定义关键词(内部群)</el-tag>设定后，只有包含关键词的消息内容才会被正常发送</div>
          <el-link slot="reference" type="danger" icon="el-icon-document-copy" :underline="false">字段说明</el-link>
        </el-popover>
        <el-alert
          title="每个机器人每分钟最多发送20条消息到群里，如果超过20条，会限流10分钟。"
          type="warning"
          :closable="false"
          style="display: inline;margin-left: 20px;"
          show-icon>
        </el-alert>
      </template>

      <template slot="menuRight">
        <el-link type="primary" href="https://kdocs.cn/l/cjuSztmgB7P1"  target="_blank" style="position:relative;right: 0.3cm" >钉钉群机器人—操作文档</el-link>
        <el-link type="primary" href="https://kdocs.cn/l/cfyWTbPZrDfZ"  target="_blank" >企业微信内部群机器人—操作文档</el-link>
      </template>

      <template slot="cjrsfzdqbmSearch">
        <el-select v-model="searchForm.cjrsfzdqbm" >
          <el-option v-for="(item,index) in selectData" :key="index" :label="item.label" :value="item.value" ></el-option>
        </el-select>
      </template>

      <template slot="sfgjqmqcSearch">
        <el-select v-model="searchForm.sfgjqmqc" >
          <el-option v-for="(item,index) in selectData" :key="index" :label="item.label" :value="item.value" ></el-option>
        </el-select>
      </template>

<!--      <template slot-scope="scope" slot="gsId">-->
<!--        {{scope.row.gsId?scope.row.gsId:"-"}}-->
<!--      </template>-->
    </avue-crud>
</template>

<script>
  import {getList, getDetail, add, update, remove} from "@/api/departmentStat/wdqz/wdqz";
  import {mapGetters} from "vuex";
  import {getCompanyList} from "@/api/departmentStat/wdqz/company";
  export default {

    data() {
      return {
        selectData:[
          {
            label:"是",
            value:1,
          },
          {
            label:"否",
            value:2,
          },
        ],
        searchForm:{
          cjrsfzdqbm:2,
          sfgjqmqc:2
        },
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        rebotDlgOption:{
          title: '',
          isShow: false,
          isAdd: true,
          noPreview: true,
          rebotInfo: {}
        },
        selectionList: [],
        option: {
          emptyText:"暂无数据",
          height:'52vh',
          calcHeight: 20,
          tip: false,
          align:"center",
          searchShow: true,
          searchMenuSpan: 3,
          searchSpan:4,
          searchBtnText:'查询',  //查询按钮
          searchMenuPosition:'left', // 搜索按钮位置 默认居中
          labelWidth:130,
          border: true,
          index: true,
          viewBtn: true,
          dialogType:'drawer',
          dialogWidth: '650px',
          // selection: true,
          dialogClickModal: false,
          span:24,
          column: [
            {
              label: "群类型",
              prop: "rebotType",
              type:"select",
              search:true,
              // change: async (row) => {
              //   this.$nextTick(async ()=>{
              //     if(row.value==1){
              //       this.findObject(this.option.column,"keyWord").display =true;
              //       // this.findObject(this.option.column,"roomProp").disabled =false;
              //     }else if(row.value==2){
              //       this.findObject(this.option.column,"keyWord").display =false;
              //       // this.findObject(this.option.column,"roomProp").disabled =false;
              //     }else {
              //       this.findObject(this.option.column,"keyWord").display =false;
              //       this.findObject(this.option.column,"roomProp").disabled =true;
              //     }
              //   });
              // },
              rules: [{
                required: true,
                message: "请选择群类型",
                trigger: "blur"
              }],
              dicData: [
                {
                  label: '钉钉群',
                  value: 1,
                },
                {
                  label: '企业微信群',
                  value: 2,
                },
                {
                  label: '微信',
                  value: 3,
                }
              ],
            },

            {
              label: "是否关联公司",
              prop: "sfglCompany",
              hide:true,
              type:"radio",
              change: async (row) => {
                  this.$nextTick(async ()=>{
                      if(row.value==1){
                        this.findObject(this.option.column,"gsId").display =true;
                        this.findObject(this.option.column,"departmentName").viewDisplay =true;
                        this.findObject(this.option.column,"code").viewDisplay =true;
                      }else{
                        this.findObject(this.option.column,"gsId").display =false;
                        this.findObject(this.option.column,"departmentName").viewDisplay =false;
                        this.findObject(this.option.column,"code").viewDisplay =false;
                      }
                  });
              },
              dicData: [
                {
                  label: '是',
                  value: 1,
                },
                {
                  label: '否',
                  value: 2,
                }
              ],
              rules: [{
                required: true,
                message: "请选择是否关联公司",
                trigger: "blur"
              }],
            },
            {
              label: "公司名称",
              overHidden: true,
              prop: "gsId",
              type:"select",
              search:true,
              display:false,
              remote: true,
              dicUrl: `/api/cube-agent/companyDetail/getcompanylist`,
              dicMethod:"post",
              dicQuery:{
                taxName:'{{key}}',
                size:10
              },
              searchFilter:true,
              filterable:true,
              dicData:[],
              input: async (row) => {
                console.log(row.value);
              },
              props: {
                label: 'taxName',
                value: 'id'
              },
              rules: [{
                required: true,
                message: "请选择公司",
                trigger: "blur"
              }],
            },
            {
              label: "部门名称",
              // display:false,
              // search:true,
              editDisplay:false,
              addDisplay:false,
              viewDisplay:false,
              prop: "departmentName",
              overHidden: true, //超出是否隐藏
              rules: [{
                required: true,
                message: "请输入所属部门",
                trigger: "blur"
              }],
              formatter: (row) => {
                if(row.departmentName) {
                        if (row.code) {
                          return row.departmentName + '(' + row.code + ')'
                        } else {
                          return row.departmentName
                        }
                }else {
                  return "-"
                }
              }
            },
            {
              label: "部门名称",
              prop: "deptId",
              editDisplay:false,
              addDisplay:false,
              viewDisplay:false,
              hide:true,
              overHidden:true,
              searchFilterable: true,
              // search:true,
              // dicUrl: '/api/cube-system/dept/deptDictionary?isShow=1',
              dicData:[],
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              type: 'select',
            },
            {
              label: "部门编码",
              prop: "code",
                hide: true,
              overHidden: true, //超出是否隐藏
              // searchSpan: 4,
              // search: true,
              addDisplay:false,
              editDisplay:false,
              viewDisplay:false,
              // searchIcon: true,
            },
            {
              label:"群性质",
              prop:"roomProp",
              disabled:true,
              type:"radio",
              dicData: [
                {
                  label: '内部群',
                  value: 1,
                },
                {
                  label: '其他',
                  value: 2,
                }
              ],
              // change: async (row) => {
              //   this.$nextTick(async ()=>{
              //     // console.log(row,"row的值");
              //     // if(row.value==1){
              //     //   this.findObject(this.option.column,"rebotName").display =true;
              //     //   this.findObject(this.option.column,"webhook").display =true;
              //     // }
              //     // else if(row.value==2){
              //     //   this.findObject(this.option.column,"rebotName").display =false;
              //     //   this.findObject(this.option.column,"webhook").display =false;
              //     // }
              //     // else {
              //     //   this.findObject(this.option.column,"rebotName").display =true;
              //     //   this.findObject(this.option.column,"webhook").display =true;
              //     // }
              //   });
              // },
              rules: [{
                required: true,
                message: "请输入群性质",
                trigger: "blur"
              }]
            },
            {
              label: "群名或微信名称",
              prop: "roomName",
              display:true,
              searchLabelWidth:130,
              overHidden:true,
              search:true,
              rules: [{
                required: true,
                message: "请输入群名或微信名称",
                trigger: "blur"
              }]
            },
            {
              label: "机器人名称",
              prop: "rebotName",
              display:true,
              overHidden:true,
              rules: [{
                required: true,
                message: "请输入机器人名称",
                trigger: "blur"
              }]
            },
            {
              label: "自定义关键词",
              display:false,
              prop: "keyWord",
              rules: [{
                required: true,
                message: "请输入安全关键词",
                trigger: "blur"
              }]
            },
            {
              label: "Webhook",
              prop: "webhook",
              type:"textarea",
              hide:true,
              overHidden:true, //内容长度过长省略号
              rules: [{
                required: true,
                message: "请输入Webhook地址",
                trigger: "blur"
              }]
            },
            {
              label: "创建人",
              prop: "createUser",
              overHidden:true,
              addDisplay: false,
              editDisplay: false,
              viewDisplay: false,
              dicData:[],
              props: {
                label: 'realName',
                value: 'id',
              },
            },
            {
              label: "创建时间",
              prop: "createTime",
              addDisplay: false,
              editDisplay: false,
              viewDisplay: false,
            },
            {
              label: "是否根据群名去重",
              prop: "sfgjqmqc",
              searchLabelWidth:130,
              display: false,
              hide:true,
              search:true,
            },
            {
              label: "创建人是否在当前部门",
              prop: "cjrsfzdqbm",
              display:false,
              searchSpan: 5,
              searchLabelWidth:160,
              search:true,
              hide:true,
              searchslot:true,
            }
          ]
        },
        data: []
      };
    },
    watch:{
      'form.gsId'(val){
        console.log(val,"12323");
      },

      "form.rebotType" : function(newValue,oldValue) {
        if(newValue  != 1){
            this.findObject(this.option.column,"keyWord").display =false;
            if(newValue == 3){
              this.findObject(this.option.column,"roomProp").disabled = true;
              this.form.roomProp =2
            }else{
              this.findObject(this.option.column,"roomProp").disabled =false;
            }
            if(this.form.roomProp == 2){
              this.findObject(this.option.column,"rebotName").display =false;
              this.findObject(this.option.column,"webhook").display =false;
            }

        }else {
             this.findObject(this.option.column,"roomProp").disabled =false;
             this.findObject(this.option.column,"keyWord").display =true;
             this.findObject(this.option.column,"rebotName").display =true;
             this.findObject(this.option.column,"webhook").display =true;
        }
      },

      "form.roomProp" : function(newValue,oldValue) {
        if(this.form.rebotType == 1 ||(this.form.rebotType == 2&&newValue ==1)){
          this.findObject(this.option.column,"rebotName").display =true;
          this.findObject(this.option.column,"webhook").display =true;
        }else {
          this.findObject(this.option.column,"rebotName").display =false;
          this.findObject(this.option.column,"webhook").display =false;
        }
      },

    },
    computed: {
      ...mapGetters(["permission","userInfo"]),
      permissionList() {
        return {
          // addBtn: this.vaildData(this.permission.rebotconfig_add, false),
          // viewBtn: this.vaildData(this.permission.rebotconfig_view, false),
          // delBtn: this.vaildData(this.permission.rebotconfig_delete, false),
          // editBtn: this.vaildData(this.permission.rebotconfig_edit, false)

          addBtn: true,
          viewBtn: true,
          delBtn: true,
          editBtn: true
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      },
    },
    created() {
      this.c_DictUser(this, 'createUser');
      this.c_DictDept(this, 'deptId');
    },
    methods: {

      rowSave(row, done, loading) {
        if(row.sfglCompany==2){
          row.gsId="";
        }
        if(row.rebotType != 1){  //不是钉钉清楚掉
          row.keyWord="";
          if(row.roomProp == 2){
            row.webhook = "";
            row.rebotName = "";
          }
        }
        add(row).then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          done();
        }, error => {
          loading();
          window.console.log(error);
        });
      },
      rowUpdate(row, index, done, loading) {
        if(row.sfglCompany==2){
          row.gsId="";
        }
        if(row.rebotType != 1){  //不是钉钉清楚掉
          row.keyWord="";
          if(row.roomProp == 2){
            row.webhook = "";
            row.rebotName = "";
          }
        }
        update(row).then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          done();
        }, error => {
          loading();
          console.log(error);
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove(row.id);
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
      },
      rebotDlg(row){
        this.rebotDlgOption.title = "群机器人测试";
        this.rebotDlgOption.isShow = true;
        this.rebotDlgOption.isAdd = true;
        this.rebotDlgOption.noPreview = true;
        this.rebotDlgOption.rebotInfo = row;
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove(this.ids);
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail(this.form.id).then(res => {
            this.form = res.data.data;
            if(this.form.gsId){
              this.form.sfglCompany=1
            }else{
              this.form.sfglCompany=2
            }
          });
        }else{
          this.form.rebotType=2
          this.form.sfglCompany=1
          this.form.roomProp=2
        }
        done();
      },
      searchReset() {
        this.query = {};
        this.onLoad(this.page);
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad(this.page, params);
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage){
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize){
        this.page.pageSize = pageSize;
      },
      refreshChange() {
        this.onLoad(this.page, this.query);
      },
       onLoad(page, params = {}) {
        this.loading = true;
        this.query.deptId=this.userInfo.bind_dept_id;
         if(this.searchForm.sfgjqmqc){
           this.query.sfgjqmqc = this.searchForm.sfgjqmqc;//是否根据群名去重
         }
         if(this.searchForm.cjrsfzdqbm){
           this.query.cjrsfzdqbm = this.searchForm.cjrsfzdqbm;//创建人是否在当前部门
         }
        getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(async res => {
          const data = res.data.data;
          let comIds = data.records.map(item=>item.gsId).filter(item => item != '').join(",");
          await getCompanyList(comIds).then(res => {
            this.findObject(this.option.column, "gsId").dicData = res.data.data;
          });
          this.$refs.crud.refreshTable();
          this.data = data.records;
          //公司Id为空赋值-
          this.data.forEach(item=>{
            if(!item.gsId){
              item.gsId="-";
            }
            if(!item.keyWord){
              item.keyWord="-";
            }
            if(!item.department){
              item.department="-"
            }
            if(!item.rebotName){
              item.rebotName="-"
            }
            if(item.rebotType == "1"){
              item.roomProp='-';
            }
          })
          this.page.total = data.total;
          this.selectionClear();
          this.loading = false;
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  /*::v-deep {*/
  /*.avue-crud__menu {*/
  /*  display: none;*/
  /*}*/
  /*}*/
</style>
